class EfReportOptionsSelector {
    constructor() {
        this.selected = []
        this.fields = []
    }

    $onChanges({ fields }) {
        if (fields.currentValue) {
            this.fields = fields.currentValue

            this.selectDefaultFields()
            this.setViewValue()
        }
    }

    $onInit() {
        this.ngModelCtrl.$render = () => {
            const { selected, format } = this.ngModelCtrl.$viewValue

            this.format = format
            this.selected = selected
        }
    }

    selectDefaultFields() {
        const selected = localStorage.getItem(this.cacheKey)

        this.selected = selected && selected !== "undefined"
            ? JSON.parse(selected)
            : this.fields
                .filter(field => !field.optional)
                .map(field => field.name)

    }

    onSelectAll() {
        this.selected = this.isAllSelected
            ? this.fields.map(f => f.name)
            : []

        this.setViewValue()
    }

    setViewValue() {
        const selected = this.fields.filter(f => this.selected.includes(f.name))
    
        this.ngModelCtrl.$setViewValue({
            selected,
            format: this.format
        })
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('efReportOptionsSelector', {
        controller: EfReportOptionsSelector,
        bindings: {
            cacheKey: '<cacheAs',
            fields: '<'
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <div>
                <div class="row">
                    <svg style="display: none">
                        <g id="file-icon">
                            <path d="M64,0v80H0v144h64v160h224l96-96V0H64z M16,208V96h240v112H16z M288,361.376V288h73.376L288,361.376z M368,272h-96v96H80    V224h192V80H80V16h288V272z"/>
                        </g>
                    </svg>
                    <div class="col-xs-12 format-buttons">
                        <label class="format-button" ng-class="{'active': $ctrl.format == 'XLSX'}">
                            <input type="radio" ng-model="$ctrl.format" ng-change="$ctrl.setViewValue()" value="XLSX"/>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 384 384">
                                <use xlink:href="#file-icon"></use>
                                <text text-anchor="middle" x="112" y="120" style="transform: scaleY(1.5) scaleX(1.2)">XLSX</text>
                            </svg>
                            XLSX
                        </label>

                        <label class="format-button" ng-class="{'active': $ctrl.format == 'CSV'}">
                            <input type="radio" ng-model="$ctrl.format" ng-change="$ctrl.setViewValue()" value="CSV"/>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 384 384">
                                <use xlink:href="#file-icon"></use>
                                <text text-anchor="middle" x="112" y="120" style="transform: scaleY(1.5) scaleX(1.2)">CSV</text>
                            </svg>
                            CSV
                        </label>

                        <label class="format-button" ng-class="{'active': $ctrl.format == 'JSON'}">
                            <input type="radio" ng-model="$ctrl.format" ng-change="$ctrl.setViewValue()" value="JSON"/>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 384 384">
                                <use xlink:href="#file-icon"></use>
                                <text text-anchor="middle" x="112" y="120" style="transform: scaleY(1.5) scaleX(1.2)">JSON</text>
                            </svg>
                            JSON
                        </label>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-xs-12">
                        <div class="col-xs-12" style="border: 1px #f7eaea solid; border-radius: 3px; padding-top: 10px; padding-bottom: 10px; margin-top: 15px; margin-bottom: 10px;">
                            <div class="smart-form">
                                <label class="checkbox">
                                    <input type="checkbox" ng-model="$ctrl.isAllSelected" ng-change="$ctrl.onSelectAll()" />
                                    <i></i>
                                    <span ng-class="{'text-bold': $ctrl.isAllSelected}">Selecionar todos</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4" ng-repeat="field in $ctrl.fields">
                            <div class="smart-form">
                                <label class="checkbox">
                                    <input type="checkbox" ng-click="$ctrl.setViewValue()" checklist-model="$ctrl.selected" checklist-value="field.name" />
                                    <i></i>
                                    <span ng-class="{'text-bold': $ctrl.selected.includes(field.name)}">{{field.description}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `
    })
